import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { abandonProcessingSession } from "./schema/abandon-processing-session";
import { addUndeclaredItemToProcessingSession } from "./schema/add-undeclared-item-to-processing-session";
import { completeProcessingSession } from "./schema/complete-processing-session";
import { createInventoryItem } from "./schema/create-inventory-item";
import { createProcessingSession } from "./schema/create-processing-session";
import { emitWarehouseReturnSortedEvent } from "./schema/emit-warehouse-return-sorted-event";
import { evaluateSpecForItem } from "./schema/evaluate-spec-for-item";
import { findOrCreateInventoryItemForProcessingSession } from "./schema/find-or-create-inventory-item-for-processing-session";
import { generateLicensePlate } from "./schema/generate-license-plate";
import { generateSortingLicensePlate } from "./schema/generate-sorting-license-plate";
import { generateUnknownLicensePlate } from "./schema/generate-unknown-license-plate";
import { getPrinters } from "./schema/get-printers";
import { getProcessingSession } from "./schema/get-processing-session";
import { getProcessingSessionSortDestinations } from "./schema/get-processing-session-sort-destinations";
import { getReturnForProcessing } from "./schema/get-return-for-processing";
import {
  completeItemProcessingSession,
  createItemProcessingSession,
  getItemProcessingSession,
  logItemProcessingEvent,
  lookupItemForProcessing,
  updateItemProcessingSession,
} from "./schema/item-processing";
import { logProcessingEvent } from "./schema/log-processing-event";
import { lookupForSorting } from "./schema/lookup-for-sorting";
import { markSessionItemAsMissing } from "./schema/mark-session-item-as-missing";
import { printLicensePlate } from "./schema/print-license-plate";
import { recordSessionItemAsReceived } from "./schema/record-session-item-as-received";
import { removeUndeclaredItemFromProcessingSession } from "./schema/remove-undeclared-item-from-processing-session";
import { updateProcessingSessionItem } from "./schema/update-processing-session-item";
import { uploadEvidencePhoto } from "./schema/upload-evidence-photo";
import { verifyPhotoQuick } from "./schema/verify-photo";

export const rpcDefinition = {
  evaluateSpecForItem,
  getReturnForProcessing,
  lookupItemForProcessing,
  createItemProcessingSession,
  getItemProcessingSession,
  updateItemProcessingSession,
  completeItemProcessingSession,
  logItemProcessingEvent,
  getProcessingSession,
  getProcessingSessionSortDestinations,
  createProcessingSession,
  createInventoryItem,
  emitWarehouseReturnSortedEvent,
  updateProcessingSessionItem,
  completeProcessingSession,
  abandonProcessingSession,
  addUndeclaredItemToProcessingSession,
  generateLicensePlate,
  findOrCreateInventoryItemForProcessingSession,
  printLicensePlate,
  generateSortingLicensePlate,
  generateUnknownLicensePlate,
  getPrinters,
  logProcessingEvent,
  lookupForSorting,
  markSessionItemAsMissing,
  recordSessionItemAsReceived,
  removeUndeclaredItemFromProcessingSession,
  uploadEvidencePhoto,
  verifyPhotoQuick,
};

export type RedoReturnsProcessingRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
